import React from "react";
import { Box, Typography } from "@mui/material";

export const Label = ({ text, marginBottom = 1.5 }: { text: string; marginBottom?: number }) => (
  <Box data-testid="label" marginBottom={marginBottom}>
    <Typography variant="main">{text}</Typography>
  </Box>
);
